import OstroDynamicContent from 'app/components/OstroDynamicContent';
import useCustomization from 'app/hooks/useCustomization';

import { type NbrCtaContentProps } from './types';

const NbrContentDesktop = ({ suggestedArticle }: NbrCtaContentProps) => {
  const customization = useCustomization();

  const actionIconUrl = customization?.open_button_action_icon;

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 pl-[12px] pr-[15px] bg-brand-openBubbleBackground flex flex-col justify-center gap-1">
        <OstroDynamicContent
          id="ostro-suggested-article-title"
          content={suggestedArticle.title}
          className="[&_p]:(m-0 inline) font-bold line-clamp-1 leading-[18px]"
        />
        <OstroDynamicContent
          id="ostro-suggested-article-description"
          content={suggestedArticle.description}
          className="[&_p]:mb-0 min-w-fit line-clamp-2 leading-[18px]"
        />
      </div>
      <div className="h-[24px] shrink-0 pl-[15px] pr-2 text-white leading-none bg-brand-openButtonBackground flex justify-between items-center">
        <span id="nbr-cta-desktop-read-more">
          {/* The id for this span is a temporary fix for css targeting */}
          Read More
        </span>
        <img
          className="w-[24px] h-[24px]"
          src={actionIconUrl}
          alt=""
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default NbrContentDesktop;
